import React, { useState } from 'react';
import { Share2, Link as LinkIcon, Check } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Native share sheet if available (mobile),
 * clipboard-copy fallback with a "Copied" pill (desktop).
 */
const SharePoemButton = ({ poem, className = '' }) => {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const url = `${window.location.origin}/poetry/${poem.id}`;
    const title = `${poem.title} \u2014 by ${poem.author}`;
    const text = `A poem for the moment you are in. From 40 Songs and a Mic.`;

    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (err) {
        // User dismissed the share sheet (AbortError) or share failed;
        // fall through to clipboard copy.
        if (err && err.name !== 'AbortError') {
          console.warn('navigator.share failed:', err);
        }
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch (err) {
      // Very old browser or clipboard permission denied.
      console.warn('clipboard write failed, falling back to prompt:', err);
      window.prompt('Copy this link:', url);
    }
  };

  return (
    <Button
      onClick={share}
      variant="outline"
      data-testid={`share-poem-${poem.id}`}
      className={`border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0a0a0a] font-bold transition-all ${className}`}
    >
      {copied ? (
        <>
          <Check className="w-4 h-4 mr-2" />
          LINK COPIED
        </>
      ) : (
        <>
          {typeof navigator !== 'undefined' && navigator.share ? (
            <Share2 className="w-4 h-4 mr-2" />
          ) : (
            <LinkIcon className="w-4 h-4 mr-2" />
          )}
          SHARE THIS POEM
        </>
      )}
    </Button>
  );
};

export default SharePoemButton;
